
  import { Record, Partial, Static, Number, String, Always, Intersect2, Constraint, Literal } from 'runtypes';

  export const ___baseEventTypeDefinition = Record({
  eventId: Literal(1008),
  kingdomId: Number.withConstraint(x => x >= 0 && x <= 1000),
  playerId: Number.withConstraint(x => x >= 0),
  posX: Number.withConstraint(x => x >= -1 && x <= 10000),
  posY: Number.withConstraint(x => x >= -1 && x <= 10000),
  reset: Number.withConstraint(x => x >= 0 && x <= 1),
}).And(Partial({
  level: Number.withConstraint(x => x >= -1 && x <= 10000),
}));
  export const ___completeEventTypeDefinition = Record({
  eventId: Literal(1008),
  kingdomId: Number.withConstraint(x => x >= 0 && x <= 1000),
  playerId: Number.withConstraint(x => x >= 0),
  posX: Number.withConstraint(x => x >= -1 && x <= 10000),
  posY: Number.withConstraint(x => x >= -1 && x <= 10000),
  reset: Number.withConstraint(x => x >= 0 && x <= 1),
  gameId: Number.withConstraint(x => x >= 1 && x <= 100),
}).And(Partial({
  level: Number.withConstraint(x => x >= -1 && x <= 10000),
  instanceId: Number.withConstraint(x => x >= 0 && x <= 1000),
  networkId: Number.withConstraint(x => x >= 0 && x <= 1000),
  zoneId: Number,
}));

  export type Event = Static<typeof ___baseEventTypeDefinition>;

  /** The event type with the shared values added */
  export type EventWithCommonParameters = Static<typeof ___completeEventTypeDefinition>;

  export const validateEvent = (o: any) => ___completeEventTypeDefinition.validate(o);

  export const ID = 1008;
  